import React from "react";
import { UserOutlined } from "@ant-design/icons";
import { Card } from "antd";

const HistoryCard = ({ header, value, icon }) => {
  const cardIcon = icon
    ? <img src={icon} alt="card-icon" className="h-[64px] w-[64px]" style={{ filter: 'invert(55%) sepia(0%) saturate(0%) brightness(90%)' }} />
    : <UserOutlined />;

  const words = header?.split(" ") ?? [];
  const line1 = words.slice(0, Math.ceil(words.length / 2)).join(" ");
  const line2 = words.slice(Math.ceil(words.length / 2)).join(" ");

  return (
    <Card
      style={{
        borderRadius: '10px',
        padding: '16px',
        boxShadow: '0px 0px 6px 0px rgba(0,0,0,0.05)',
        width: '121px',
        height:"260px"
      }}
      styles={{ body: { padding: 0 } }}
    >
      <div className="flex flex-col justify-center items-center gap-4 w-full h-[228px]">

   
        <div className="flex justify-center ">
          {cardIcon}
        </div>

        <div className="flex justify-center">
          <span
            className="font-['Inter'] font-semibold leading-none tracking-normal text-[var(--color-primary-100)]"
            style={{ fontSize: '28px' }}
          >
            {value}
          </span>
        </div>

        <div className="flex flex-col items-center text-center">
          <span className="text-sm font-medium text-[#8B8B8B] leading-snug">{line1}</span>
          <span className="text-sm font-medium text-[#8B8B8B] leading-snug">{line2}</span>
        </div>

      </div>
    </Card>
  );
};

export default HistoryCard;